const successResult = (msg = "", data = null) => ({
	success: true,
	msg: msg,
	data: data,
})

const errorResult = (err, data = null) => ({
	success: false,
	err: err,
	data: data,
})

const resulter = {
	successResult,
	errorResult,
}

export default resulter